module.exports = __webpack_public_path__ + "static/media/llantas.86c0cbf6.svg";